import {
    FETCH_LANG_MENU_SUCCESS,
    FETCH_LANG_DATE_FILTER_SUCCESS,
    FETCH_LANG_FULL_MONTH_SUCCESS,
    FETCH_LANG_SHORT_MONTH_SUCCESS,
    FETCH_LANG_MASTER_SUCCESS
} from '../constants/ActionTypes';

const initialState = {
    langMenu: {
        menuPerformanceOverall: "ประสิทธิภาพโดยรวม",
        menuCustomer: "ระบบจัดการข้อมูลลูกค้า",
        menuCustomerOverall: "สรุปข้อมูลลูกค้า",
        menuCustomerFocus: "ข้อมูลลูกค้า",
        menuLogout: "ออกจากระบบ"
    },
    langDateFilter: {
        labelYear: "ปี",
        labelQuarter: "ไตรมาส",
        labelMonth: "เดือน",
        selectYear: "เลือกปี",
        selectQuarter: "เลือกไตรมาส",
        selectMonth: "เลือกเดือน"
    },
    langFullMonth: {
        january: "มกราคม",
        february: "กุมภาพันธ์",
        march: "มีนาคม",
        april: "เมษายน",
        may: "พฤษภาคม",
        june: "มิถุนายน",
        july: "กรกฏาคม",
        august: "สิงหาคม",
        september: "กันยายน",
        october: "ตุลาคม",
        november: "พฤศจิกายน",
        december: "ธันวาคม",
    },
    langShortMonth: {
        jan: "ม.ค.",
        feb: "ก.พ.",
        mar: "มี.ค.",
        apr: "เม.ย.",
        may: "พ.ค.",
        jun: "มิ.ย.",
        jul: "ก.ค.",
        aug: "ส.ค.",
        sep: "ก.ย.",
        oct: "ต.ค.",
        nov: "พ.ย.",
        dec: "ธ.ค.",
    },
    langMaster: {
        person: "ราย",
        persons: "ราย",
        baht: "บาท",
        day: "วัน",
        amount: "ยอดขาย",
        quantity: "จำนวน",
        percentage: "เปอร์เซ็น",
        previousSales: "ยอดขายก่อนหน้า",
        currentSales: "ยอดขายปัจจุบัน",
        total: "รวม",
        currentYear: "ปีปัจจุบัน",
        previousYear: "ปีก่อน",
        currentQuarter: "ไตรมาสปัจจุบัน",
        previousQuarter: "ไตรมาสก่อน",
        currentMonth: "เดือนปัจจุบัน",
        previousMonth: "เดือนก่อน",
        search: "ค้นหา",
        status: "สถานะ",
        year: "ปี",
        quarter: "ไตรมาส",
        month: "เดือน",
        selectYear: "เลือกปี",
        selectQuarter: "เลือกไตรมาส",
        selectMonth: "เลือกเดือน",
        noData: "ไม่มีข้อมูล",
        connect: "เชื่อมต่อ",
        disconnect: "ปิดการเชื่อมต่อ",
        customer: "ลูกค้า",
        ranking: "อันดับ",
        group: "กลุ่ม",
        address: "ที่อยู่",
        province: "จังหวัด",
        tel: "เบอร์โทร",
        map: "แผนที่",
        contactPerson: "ผู้ติดต่อ",
        noContactPerson: "ไม่มีผู้ติดต่อ",
        aboutus: "เกี่ยวกับเรา",
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LANG_MENU_SUCCESS:
            return {
                ...state,
                langMenu: {
                    menuPerformanceOverall: action.payload.menuPerformanceOverall 
                        ? action.payload.menuPerformanceOverall : initialState.langMenu.menuPerformanceOverall,
                    menuCustomer: action.payload.menuCustomer 
                        ? action.payload.menuCustomer : initialState.langMenu.menuCustomer,
                    menuCustomerOverall: action.payload.menuCustomerOverall 
                        ? action.payload.menuCustomerOverall : initialState.langMenu.menuCustomerOverall,
                    menuCustomerFocus: action.payload.menuCustomerFocus
                        ? action.payload.menuCustomerFocus : initialState.langMenu.menuCustomerFocus,
                    menuLogout: action.payload.menuLogout
                        ? action.payload.menuLogout : initialState.langMenu.menuLogout,
                }
            }
        case FETCH_LANG_DATE_FILTER_SUCCESS:
            return {
                ...state,
                langDateFilter: {
                    labelYear: action.payload.labelYear
                        ? action.payload.labelYear : initialState.langDateFilter.labelYear,
                    labelQuarter: action.payload.labelQuarter
                        ? action.payload.labelQuarter : initialState.langDateFilter.labelQuarter,
                    labelMonth: action.payload.labelMonth
                        ? action.payload.labelMonth : initialState.langDateFilter.labelMonth,
                    selectYear: action.payload.selectYear
                        ? action.payload.selectYear : initialState.langDateFilter.selectYear,
                    selectQuarter: action.payload.selectQuarter
                        ? action.payload.selectQuarter : initialState.langDateFilter.selectQuarter,
                    selectMonth: action.payload.selectMonth
                        ? action.payload.selectMonth : initialState.langDateFilter.selectMonth,
                }
            }
        case FETCH_LANG_FULL_MONTH_SUCCESS:
            return {
                ...state,
                langFullMonth: {
                    january: action.payload.january
                        ? action.payload.january : initialState.langFullMonth.january,
                    february: action.payload.february
                        ? action.payload.february : initialState.langFullMonth.february,
                    march: action.payload.march
                        ? action.payload.march : initialState.langFullMonth.march,
                    april: action.payload.april
                        ? action.payload.april : initialState.langFullMonth.april,
                    may: action.payload.may
                        ? action.payload.may : initialState.langFullMonth.may,
                    june: action.payload.june
                        ? action.payload.june : initialState.langFullMonth.june,
                    july: action.payload.july
                        ? action.payload.july : initialState.langFullMonth.july,
                    august: action.payload.august
                        ? action.payload.august : initialState.langFullMonth.august,
                    september: action.payload.september
                        ? action.payload.september : initialState.langFullMonth.september,
                    october: action.payload.october
                        ? action.payload.october : initialState.langFullMonth.october,
                    november: action.payload.november
                        ? action.payload.november : initialState.langFullMonth.november,
                    december: action.payload.december
                        ? action.payload.december : initialState.langFullMonth.december,
                }
            }
        case FETCH_LANG_SHORT_MONTH_SUCCESS:
            return {
                ...state,
                langShortMonth: {
                    jan: action.payload.jan
                        ? action.payload.jan : initialState.langShortMonth.jan,
                    feb: action.payload.feb
                        ? action.payload.feb : initialState.langShortMonth.feb,
                    mar: action.payload.mar
                        ? action.payload.mar : initialState.langShortMonth.mar,
                    apr: action.payload.apr
                        ? action.payload.apr : initialState.langShortMonth.apr,
                    may: action.payload.may
                        ? action.payload.may : initialState.langShortMonth.may,
                    jun: action.payload.jun
                        ? action.payload.jun : initialState.langShortMonth.jun,
                    jul: action.payload.jul
                        ? action.payload.jul : initialState.langShortMonth.jul,
                    aug: action.payload.aug
                        ? action.payload.aug : initialState.langShortMonth.aug,
                    sep: action.payload.sep
                        ? action.payload.sep : initialState.langShortMonth.sep,
                    oct: action.payload.oct
                        ? action.payload.oct : initialState.langShortMonth.oct,
                    nov: action.payload.nov
                        ? action.payload.nov : initialState.langShortMonth.nov,
                    dec: action.payload.dec
                        ? action.payload.dec : initialState.langShortMonth.dec,
                }
            }
        case FETCH_LANG_MASTER_SUCCESS: 
            return {
                ...state,
                langMaster: {
                    person: action.payload.person
                        ? action.payload.person : initialState.langMaster.person,
                    persons: action.payload.persons
                        ? action.payload.persons : initialState.langMaster.persons,
                    baht: action.payload.baht
                        ? action.payload.baht : initialState.langMaster.baht,
                    day: action.payload.day
                        ? action.payload.day : initialState.langMaster.day,
                    amount: action.payload.amount
                        ? action.payload.amount : initialState.langMaster.amount,
                    quantity: action.payload.quantity
                        ? action.payload.quantity : initialState.langMaster.quantity,
                    percentage: action.payload.percentage
                        ? action.payload.percentage : initialState.langMaster.percentage,
                    previousSales: action.payload.previousSales
                        ? action.payload.previousSales : initialState.langMaster.previousSales,
                    currentSales: action.payload.currentSales
                        ? action.payload.currentSales : initialState.langMaster.currentSales,
                    total: action.payload.total
                        ? action.payload.total : initialState.langMaster.total,
                    currentYear: action.payload.currentYear
                        ? action.payload.currentYear : initialState.langMaster.currentYear,
                    previousYear: action.payload.previousYear
                        ? action.payload.previousYear : initialState.langMaster.previousYear,
                    currentQuarter: action.payload.currentQuarter
                        ? action.payload.currentQuarter : initialState.langMaster.currentQuarter,
                    previousQuarter: action.payload.previousQuarter
                        ? action.payload.previousQuarter : initialState.langMaster.previousQuarter,
                    currentMonth: action.payload.currentMonth
                        ? action.payload.currentMonth : initialState.langMaster.currentMonth,
                    previousMonth: action.payload.previousMonth
                        ? action.payload.previousMonth : initialState.langMaster.previousMonth,
                    search: action.payload.search
                        ? action.payload.search : initialState.langMaster.search,
                    status: action.payload.status
                        ? action.payload.status : initialState.langMaster.status,
                    year: action.payload.year
                        ? action.payload.year : initialState.langMaster.year,
                    quarter: action.payload.quarter
                        ? action.payload.quarter : initialState.langMaster.quarter,
                    month: action.payload.month
                        ? action.payload.month : initialState.langMaster.month,
                    selectYear: action.payload.selectYear
                        ? action.payload.selectYear : initialState.langMaster.selectYear,
                    selectQuarter: action.payload.selectQuarter
                        ? action.payload.selectQuarter : initialState.langMaster.selectQuarter,
                    selectMonth: action.payload.selectMonth
                        ? action.payload.selectMonth : initialState.langMaster.selectMonth,
                    noData: action.payload.noData
                        ? action.payload.noData : initialState.langMaster.noData,
                    connect: action.payload.connect
                        ? action.payload.connect : initialState.langMaster.connect,
                    disconnect: action.payload.disconnect
                        ? action.payload.disconnect : initialState.langMaster.disconnect,
                    customer: action.payload.customer
                        ? action.payload.customer : initialState.langMaster.customer,
                    ranking: action.payload.ranking
                        ? action.payload.ranking : initialState.langMaster.ranking,
                    group: action.payload.group
                        ? action.payload.group : initialState.langMaster.group,
                    address: action.payload.address
                        ? action.payload.address : initialState.langMaster.address,
                    province: action.payload.province
                        ? action.payload.province : initialState.langMaster.province,
                    tel: action.payload.tel
                        ? action.payload.tel : initialState.langMaster.tel,
                    map: action.payload.map
                        ? action.payload.map : initialState.langMaster.map,
                    contactPerson: action.payload.contactPerson
                        ? action.payload.contactPerson : initialState.langMaster.contactPerson,
                    noContactPerson: action.payload.noContactPerson
                        ? action.payload.noContactPerson : initialState.langMaster.noContactPerson,
                    aboutus: action.payload.aboutus
                        ? action.payload.aboutus : initialState.langMaster.aboutus,
                }
            }
        default:
            return state;
    }
}
